module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details Mydetails_order"
  }, [_c('navbar'), _vm._v(" "), _c('steps', {
    attrs: {
      "current": 0
    }
  }, [_c('step', {
    attrs: {
      "title": _vm.$t('order_details_state_1')
    }
  }), _vm._v(" "), _c('step', {
    attrs: {
      "title": _vm.$t('order_details_state_2')
    }
  }), _vm._v(" "), _c('step', {
    attrs: {
      "title": _vm.$t('order_details_state_3')
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "order-list",
    staticStyle: {
      "margin": "5% 0"
    }
  }, [_c('h3', {
    staticClass: "listing details-width"
  }, [_vm._v(_vm._s(_vm.$t('user_order_goods_lists')))]), _vm._v(" "), _c('listing', {
    attrs: {
      "lists": _vm.goods_list
    }
  })], 1), _vm._v(" "), _c('my-address', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLogin),
      expression: "isLogin"
    }],
    on: {
      "on-checked": _vm.onChecked,
      "on-address": _vm.checkAddr,
      "on-checkstore": _vm.checkstore
    }
  }), _vm._v(" "), _c('my-payment', {
    on: {
      "on-checked-radio": _vm.onChecked_radio
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "order-payment details-width"
  }, [_c('div', {
    staticClass: "pay-left"
  }, [_c('p', {
    staticClass: "payment-text"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('user_order_pay_tips')))])]), _vm._v(" "), _c('div', {
    staticClass: "pay-right"
  }, [_c('div', {
    staticClass: "payment-mey",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("My Coupon：\n                "), _c('span', [_c('Input', {
    attrs: {
      "placeholder": "Input coupon code"
    },
    model: {
      value: (_vm.coupon_code),
      callback: function($$v) {
        _vm.coupon_code = $$v
      },
      expression: "coupon_code"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "mycoupon-sel",
    class: {
      transform: _vm.show
    },
    attrs: {
      "src": require("../../assets/store/unfold.png"),
      "alt": "",
      "width": "20"
    },
    on: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "mycoupon-box"
  }, _vm._l((_vm.coupons), function(coupon, index) {
    return _c('label', {
      staticClass: "profile-radio mycoupon-radio",
      on: {
        "click": function($event) {
          _vm.checkRadio(index, $event)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/store/coupons.png"),
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "pro-radio",
      class: {
        'pro-radio-checked': _vm.tag == index
      }
    }, [_c('span', {
      staticClass: "pro-radio-inner"
    }), _vm._v(" "), _c('input', {
      staticClass: "pro-radio-input",
      attrs: {
        "type": "radio"
      }
    })])])
  })) : _vm._e()])], 1), _vm._v(" "), _c('p', {
    staticClass: "text-primary"
  }, [_vm._v("- USD 00")])]), _vm._v(" "), _c('p', {
    staticClass: "payment-mey payment-space"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('user_order_shipping')) + "：")]), _vm._v(" "), (_vm.ispayment) ? _c('span', {
    staticClass: "text-primary"
  }, [_vm._v(" USD $" + _vm._s(_vm.freight))]) : _c('span', {
    staticClass: "text-primary"
  }, [_vm._v("+ USD 0")])]), _vm._v(" "), _c('p', {
    staticClass: "payment-mey payment-space"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('user_center_order_total_tip')) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "text-primary"
  }, [_vm._v(" USD $" + _vm._s(_vm.subtotal))])]), _vm._v(" "), _c('div', {
    staticClass: "payment-del"
  }, [_c('p', [_c('span', [_vm._v(_vm._s(_vm.$t('Order_Details_Payment_Real_Payment')) + ": ")]), _vm._v(" "), (_vm.ispayment) ? _c('span', {
    staticClass: "real-pay text-primary",
    staticStyle: {
      "vertical-align": "middle"
    }
  }, [_vm._v("USD $" + _vm._s(_vm.subtotal + _vm.freight))]) : _c('span', {
    staticClass: "real-pay text-primary",
    staticStyle: {
      "vertical-align": "middle"
    }
  }, [_vm._v("USD $" + _vm._s(_vm.subtotal))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.defaultAddress.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.defaultAddress.email))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.defaultAddress.all_address))])]), _vm._v(" "), _c('p', {
    staticClass: "payment-mey"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'FooterShop'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('continue_purchase')))]), _vm._v(" "), _c('span', [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.checkOut
    }
  }, [_vm._v(_vm._s(_vm.$t('check_out_btn')))])])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-191dcc26","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyDetails/Settlement.vue
// module id = 787
// module chunks = 0